import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Passeios de Barco em Faro · Iate Privado · Morningstar";
const DESC =
  "Passeios de barco privados a partir de Faro no Morningstar — embarque na Marina de Vilamoura com transfer fácil do Aeroporto de Faro. Ria Formosa, Gruta de Benagil e cruzeiros pôr do sol.";
const PATH = "/pt/passeios-de-barco-faro";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/passeios-de-barco-faro")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Passeios de Barco em Faro · Algarve",
        title: "Passeios de barco em Faro a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Transfer direto do Aeroporto de Faro à Marina de Vilamoura — Ria Formosa, ilhas de Tavira, gruta de Benagil e cruzeiros pôr do sol pela costa algarvia.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu dia",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "passeios de barco Faro, aluguer barco Faro, charter iate Faro, Ria Formosa barco, cruzeiro Algarve Faro",
      altPath: { en: "/boat-trips-faro", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Passeios de barco privados a partir de Faro",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura → Ria Formosa / costa algarvia → paragem para mergulho → regresso.",
              durationHours: 5,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Passeios de Barco Faro", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});